import { IStreamAggregateData } from "@formant/core/model/IStreamAggregateData";
import { StreamType } from "@formant/core/model/StreamType";

export function filterAggregateByType<T extends StreamType>(
    datas: IStreamAggregateData[],
    type: T,
): IStreamAggregateData<T>[] {
    return datas.filter(_ => _.type === type) as IStreamAggregateData<T>[];
}
